import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import Label from "@/pages/Label";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Studio from "@/pages/Studio";
import ArtistesProjets from "@/pages/ArtistesProjets";
import ProjetsCulturels from "@/pages/ProjetsCulturels";
import { Actualites, ActualiteDetail } from "@/pages/Actualites";
import Contact from "@/pages/Contact";
import BookingArtist from "@/pages/BookingArtist";
import BookingStudio from "@/pages/BookingStudio";
import PaymentResult from "@/pages/PaymentResult";
import Legal from "@/pages/Legal";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminReservations from "@/pages/admin/AdminReservations";
import AdminCalendar from "@/pages/admin/AdminCalendar";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminClients from "@/pages/admin/AdminClients";
import AdminServices from "@/pages/admin/AdminServices";
import AdminAvailability from "@/pages/admin/AdminAvailability";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminSettings from "@/pages/admin/AdminSettings";
import { AdminArtists, AdminProjects, AdminNews, AdminCultural } from "@/pages/admin/AdminContent";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Chargement…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

const P = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <Routes>
          <Route path="/" element={P(<Home />)} />
          <Route path="/label" element={P(<Label />)} />
          <Route path="/label/artistes" element={P(<ArtistesProjets />)} />
          <Route path="/services" element={P(<Services />)} />
          <Route path="/services/:slug" element={P(<ServiceDetail />)} />
          <Route path="/studio" element={P(<Studio />)} />
          <Route path="/artistes" element={P(<ArtistesProjets />)} />
          <Route path="/projets-culturels" element={P(<ProjetsCulturels />)} />
          <Route path="/actualites" element={P(<Actualites />)} />
          <Route path="/actualites/:slug" element={P(<ActualiteDetail />)} />
          <Route path="/contact" element={P(<Contact />)} />
          <Route path="/booking" element={P(<BookingArtist />)} />
          <Route path="/booking-studio" element={P(<BookingStudio />)} />
          <Route path="/booking-studio/resultat" element={P(<PaymentResult />)} />
          <Route path="/mentions-legales" element={P(<Legal page="mentions-legales" />)} />
          <Route path="/confidentialite" element={P(<Legal page="confidentialite" />)} />
          <Route path="/cgv" element={P(<Legal page="cgv" />)} />
          <Route path="/conditions-reservation" element={P(<Legal page="conditions-reservation" />)} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="reservations" element={<AdminReservations />} />
            <Route path="calendrier" element={<AdminCalendar />} />
            <Route path="paiements" element={<AdminPayments />} />
            <Route path="clients" element={<AdminClients />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="disponibilites" element={<AdminAvailability />} />
            <Route path="artistes" element={<AdminArtists />} />
            <Route path="projets" element={<AdminProjects />} />
            <Route path="actualites" element={<AdminNews />} />
            <Route path="culturels" element={<AdminCultural />} />
            <Route path="demandes" element={<AdminRequests />} />
            <Route path="parametres" element={<AdminSettings />} />
          </Route>

          <Route path="*" element={P(<Home />)} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
